import { AdgroupFormData, CampaignFormData, IdentityItem, IdentityInfo } from '@tt4b/ttam-enums';
import {
  useRequest,
  useStdAdgroupIs,
  useShowcaseIdentityListApi,
  useStore,
  StateEnum,
  ValidationError,
} from '@tt4b/ttam-hooks';
import { i18n } from './../../../i18n';
import { computed, Ref, onMounted, ref } from '@vue/composition-api';
import { handelIdentityItem } from './../../identity/hooks';

export function useShowcaseArea() {
  const { getStore } = useStore();
  const { data, isLoading, isEmpty, run, runningPromise } = getStore(
    StateEnum.showcaseArea,
    undefined as any,
    false,
    false,
  );

  const getShowcaseArea = (params: Partial<IdentityInfo>) =>
    run({
      identityId: params.identityId,
      identityType: params.identityType,
    });

  return {
    showcaseLocations: computed(() => data.value || []),
    isLoading,
    isEmpty,
    getShowcaseArea,
    runningPromise,
  };
}

export function useShowcaseIdentityListDataSource(opt: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { adgroupData, campaignData } = opt;
  const { isLiveAds, isStandardAds, isProductFromShowcase } = useStdAdgroupIs({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
  });
  const { run, data, isLoading, error } = useRequest(useShowcaseIdentityListApi, {} as any, { manual: true });

  const originalData = computed(() => data.value?.identityList ?? []);
  const isEmpty = computed(() => originalData.value?.length < 1);

  const dataSource = computed<IdentityItem[]>(() =>
    data.value?.identityList?.map(item =>
      handelIdentityItem(
        {
          ...item,
          displayName: i18n.t('module_creative_showcase_identity_name', { identity: item.displayName }) as string,
        },
        {
          isShopLive: isLiveAds.value,
          isStandardAds: isStandardAds.value,
          isProductFromShowcase: isProductFromShowcase.value,
        },
      ),
    ),
  );
  const hasLoaded = ref(false);
  onMounted(() => {
    run().then(() => {
      hasLoaded.value = true;
    });
  });

  return {
    run,
    error,
    isLoading,
    dataSource,
    originalData,
    isEmpty,
    hasLoaded,
  };
}

export function useRules() {
  return {
    showcaseValidator: computed(() => [
      {
        validator: (rule, value, callback) => {
          if (!value) {
            return callback(
              new ValidationError({
                messageI18nKey: 'module_creative_showcase_select_placeholder',
                message: i18n.t('module_creative_showcase_select_placeholder'),
                moduleName: i18n.t('module_specify_product_source'),
                subModuleName: i18n.t('module_adgroup_product_setting_shop'),
              }),
            );
          }
          return callback();
        },
      },
    ]),
  };
}
